import { Text, View, StyleSheet, Image, Font, Svg, Circle, Path, Defs, Marker, Polygon, Line } from "@react-pdf/renderer";
import { React, useState, useEffect } from "react";

const FlowImg = require("../../../Assets/Images/Flow.png");
const LatoRegular = require("../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    borderRadius: "5px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lato",
    backgroundColor: "#ffffff",
    padding: "20px",
  },
  topSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  coverTitle: {
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "30px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  contentContainer: {
    textAlign: "left",
    maxWidth: "800px",
    marginTop: "10px",
  },
  highlightText: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Lato",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
    marginTop: "5px",
  },
  coverImage: {
    width: "40%",
    maxWidth: "300px",
  },
  textContent: {
    width: "55%",
  },
   container: {
    width: 250,
    height: 250,
    position: 'relative',
    border: '2px solid black',
    margin: '20px auto',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  label: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#000',
    position: 'absolute',
  },
  topLeft: { top: -15, left: 5 },
  topRight: { top: -15, right: 5 },
  bottomLeft: { bottom: -15, left: 5 },
  bottomRight: { bottom: -15, right: 5 },
  percentage: {
    fontSize: 10,
    fontWeight: 'bold',
    position: 'absolute',
    color: '#000',
  },
  pTopLeft: { top: 10, left: 10 },
  pTopRight: { top: 10, right: 10 },
  pBottomLeft: { bottom: 10, left: 10 },
  pBottomRight: { bottom: 10, right: 10 },
  centerLine: {
  position: 'absolute',
  backgroundColor: '#000',
},

verticalLine: {
  width: 2,
  height: 246,
  left: '50%',
  top: 0,
  transform: [{ translateX: -0.5 }],
},

horizontalLine: {
  height: 2,
  width: 238,
  top: '50%',
  left: 0,
  transform: [{ translateY: -0.5 }],
},
});

const  QuadrantFlowPage1 = ({ apiData }) => {
  const [highestStarter, setHighestStarter] = useState('')
  const [mostSelecTedStarter, setMostSelecTedStarter] = useState('')
  const [secondMostSelecTedStarter, setSecondMostSelecTedStarter] = useState('')
  const [snapshotResult, setSnapshotResults] = useState([])
  const [starterLabel, setStarterLabel] = useState([])
        
  const [variablsMapArray, setVariableMapArray] = useState()
  const [scoreRanking, setScoreRanking] = useState([])
          
  console.log('apiData', apiData)
      
  const pairs = [
    { round1: "heart_round1_m", round2: "heart_round2_m" },
    { round1: "soul_round1_m", round2: "soul_round2_m" },
    { round1: "str_round1_m", round2: "str_round2_m" },
    { round1: "mind_round1_m", round2: "mind_round2_m" }
  ];
      
  const variableMap = apiData?.variables?.reduce((acc, el) => {
    acc[el.variable] = el.score;
    return acc;
  }, {});
  useEffect(() => {
    if (apiData?.variables) {
      const nextMap = apiData.variables.reduce((acc, el) => {
        acc[el.variable] = el.score;
        return acc;
      }, {});
      setVariableMapArray(nextMap);
    }
    console.log("apiData", apiData)
  }, [apiData?.variables]);
      
  useEffect(() => {
    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];
          
    if (variablsMapArray) {
      console.log(variablsMapArray);
      const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
      const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
      const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
      const strength_r1_m = variablsMapArray["str_round1_m"] || 0;
          
      const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
      const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
      const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
      const strength_r2_m = variablsMapArray["str_round2_m"] || 0;
          
      const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
      const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
      const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
      const strength_r1_l = variablsMapArray["str_round1_l"] || 0;
          
      const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
      const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
      const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
      const strength_r2_l = variablsMapArray["str_round2_l"] || 0;
          
      const heart_highest = Math.max(heart_r1_m, heart_r2_m, heart_r1_l, heart_r2_l);
      const mind_highest = Math.max(mind_r1_m, mind_r2_m, mind_r1_l, mind_r2_l);
      const soul_highest = Math.max(soul_r1_m, soul_r2_m, soul_r1_l, soul_r2_l);
      const strength_highest = Math.max(strength_r1_m, strength_r2_m, strength_r1_l, strength_r2_l);
      
      console.log("Heart Highest = " + heart_highest + "\nMind Highest = " + mind_highest + "\nSoul Highest = " + soul_highest + "\nStrength Highest = " + strength_highest);
      // let testingVarsM2 = [heart_r2 + heart_r1_m, soul_r2 + soul_round1_m, mind_r2 + mind_round1_m, strength_r2 + strength_round1_m];
      let testingVarsM2Pair = [{"name": "heart", "score": heart_highest},{"name": "soul", "score": soul_highest},{"name": "mind", "score": mind_highest}, {"name": "strength", "score": strength_highest}];
      console.log("testingVarsM2Pair",testingVarsM2Pair);
          
      highestVariable = testingVarsM2Pair.reduce((max, current) => 
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );
          
          
      let most_score = Math.max(heart_r1_m,soul_r1_m,mind_r1_m,strength_r1_m)
      // let second_most_score = Math.max(heart_r2_m,soul_r2_m,mind_r2_m,strength_r2_m) / 2
      // let least_score = Math.max(heart_r1_l,soul_r1_l,mind_r1_l,strength_r1_l)
      // let second_least_score = Math.max(heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l) / 2
  
      const secondMostRawScoreMap = {
        Heart: heart_r2_m,
        Soul: soul_r2_m,
        Mind: mind_r2_m,
        Strength: strength_r2_m
      };
      const secondLeastRawScoreMap = {
        Heart: heart_r2_l,
        Soul: soul_r2_l,
        Mind: mind_r2_l,
        Strength: strength_r2_l
      };
      const mostScoreMap = {
        Heart: heart_r1_m,
        Soul: soul_r1_m,
        Mind: mind_r1_m,
        Strength: strength_r1_m
      };
      const leastScoreMap = {
        Heart: heart_r1_l,
        Soul: soul_r1_l,
        Mind: mind_r1_l,
        Strength: strength_r1_l
      };
  
    const raw_second_most_score = Math.max(...Object.values(secondMostRawScoreMap));
    const raw_second_least_score = Math.max(...Object.values(secondLeastRawScoreMap));
  
    let second_most_score = raw_second_most_score / 2;
    let least_score = Math.max(...Object.values(leastScoreMap));
    let second_least_score = raw_second_least_score / 2;
  
    if (least_score >= second_least_score) {
      least_score = second_least_score - 1;
    }
  
    let most_scored_label = Object.keys(mostScoreMap).find(key => mostScoreMap[key] === most_score);
    let second_most_scored_label = Object.keys(secondMostRawScoreMap).find(key => secondMostRawScoreMap[key] === raw_second_most_score);
    let least_scored_label = Object.keys(leastScoreMap).find(key => leastScoreMap[key] === least_score);
    let second_least_scored_label = Object.keys(secondLeastRawScoreMap).find(key => secondLeastRawScoreMap[key] === raw_second_least_score);
          
      console.log("heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l",heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l)
      if ( least_score >= second_least_score ) {
        least_score = ( second_least_score - 1 )
      }
          
      const total = most_score + second_most_score + least_score + second_least_score;
          
      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score/ total) * 100 
          
      console.log("scores-",most_score,second_most_score,least_score,second_least_score)
      console.log("scores-per",most_per,second_most_per,least_score,second_least_per)
          
            
      let labels = testingVarsM2Pair.map(item => item.name);
          
      const labels_arr = ["heart", "soul", "mind", "strength"];
          
      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];
          
      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);
          
      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];
          
      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);
          
      console.log(most_label , 'most_label')
      const getPercentageOrder = ( label ) => {
        if ( label === most_label?.toLowerCase() ) {
          return most_per;
        }
        if ( label === second_most_label?.toLowerCase() ) {
          return second_most_per;
        }
        if ( label === least_label?.toLowerCase() ) {
          return least_per;
        }
        if ( label === second_least_label?.toLowerCase() ) {
          return second_least_per;
        }
          
        return 0
      }
          
      console.log("scores- starter",most_score,second_most_score,least_score,second_least_score)
      console.log("scores-per-starter",most_per,second_most_per,least_score,second_least_per)
          
      // order should be most > second most > least > second least
      // results = [getPercentageOrder("mind"), getPercentageOrder("soul"), getPercentageOrder("strength"), getPercentageOrder("heart")] // label order = 'mind', 'soul', 'strength', 'heart'
      results = [getPercentageOrder("strength"), getPercentageOrder("heart"), getPercentageOrder("soul"), getPercentageOrder("mind")] // label order = 'mind', 'soul', 'strength', 'heart'
               
      // labelsArray = [...labelsArray, ...labels];
      // labelsArray = [least_label, second_least_label, second_most_label, most_label];
      labelsArray = ['mind', 'soul', 'strength', 'heart'];
      
      const RankedScores = [
        { name: most_scored_label, value: most_per },
        { name: second_most_scored_label, value: second_most_per },
        { name: least_scored_label, value: least_score },
        { name: second_least_scored_label, value: second_least_per }
      ];
            
      RankedScores.sort((a, b) => b.value - a.value);
      
      console.log(RankedScores)
      
      setScoreRanking(RankedScores)
          
      console.log('highestVariable', highestVariable)
      console.log("pie chart results", results);
      console.log("pie chart labelsArray", labelsArray);
          
      setHighestStarter(most_label);
      // setStarterScore(most_per);
      setSnapshotResults(results);
      setStarterLabel(labelsArray);
      getMostAndSecondMostVaribale(apiData)
    }
          
  }, [variablsMapArray]);
      
  const getMostAndSecondMostVaribale = () => {
    if (apiData?.variables?.length > 0) {
      const extractCoreVariable = (variable) =>
        variable?.split("_")[0];
            
      const highestRound1Variable = pairs
      ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
      ?.filter(Boolean)
      ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });
      
      const highestRound2Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round2))
        ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });
      
      const coreRound1 = extractCoreVariable(highestRound1Variable?.variable);
      const coreRound2 = extractCoreVariable(highestRound2Variable?.variable);
      
      if (coreRound1 === coreRound2) {
        const secondHighestRound1Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
        ?.filter(Boolean)
        ?.sort((a, b) => b?.score - a?.score)
        ?.find((v) => v?.variable !== highestRound1Variable?.variable);
      
        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(secondHighestRound1Variable?.variable || null);
      } else {
        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(highestRound2Variable?.variable || null);
      }
            
      console.log(
        highestRound1Variable?.variable,
        highestRound2Variable?.variable,
        "highest"
      );
    }
  }
  
  const sortedScores = scoreRanking.sort((a, b) => b.value - a.value);
  
  console.log('scoreRanking-new', scoreRanking)
  
  const sortedAndRoundedArray = [...snapshotResult]
  .sort((a, b) => b - a)  
  .map(value => Math.round(value)); 
  
  
console.log('resultString', sortedAndRoundedArray)

  const SquareWithArrow = () => {
    const mindIndex = starterLabel.indexOf('mind');
    const soulIndex = starterLabel.indexOf('soul');
    const strengthIndex = starterLabel.indexOf('strength');
    const heartIndex = starterLabel.indexOf('heart');

    const rawValues = {
      mind: mindIndex !== -1 ? snapshotResult[mindIndex] : 0,
      soul: soulIndex !== -1 ? snapshotResult[soulIndex] : 0,
      strength: strengthIndex !== -1 ? snapshotResult[strengthIndex] : 0,
      heart: heartIndex !== -1 ? snapshotResult[heartIndex] : 0
    };

    const total = Object.values(rawValues).reduce((sum, val) => sum + val, 0);

    const roundedValues = {};
    Object.entries(rawValues).forEach(([key, value]) => {
      roundedValues[key] = Math.round((value / total * 100) * 10) / 10;
    });

    const roundedTotal = Object.values(roundedValues).reduce((sum, val) => sum + val, 0);

    const largestKey = Object.entries(roundedValues).reduce((a, b) => b[1] > a[1] ? b : a)[0];
    roundedValues[largestKey] += (100 - roundedTotal);

    const finalValues = {
      mind: Math.round(roundedValues.mind),
      soul: Math.round(roundedValues.soul),
      strength: Math.round(roundedValues.strength),
      heart: Math.round(roundedValues.heart)
    };

    const topLeft = sortedScores[2]?.name || "Mind";
    const topRight = sortedScores[3]?.name || "Strength";
    const bottomLeft = sortedScores[1]?.name || "Soul";
    const bottomRight = sortedScores[0]?.name || "Heart";

    return (
      <div style={{ 
        position: 'relative', 
        width: '250px', 
        height: '250px', 
        backgroundColor: 'transparent', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        border: '2px solid #000',
        margin: '20px auto'
      }}>
        <div style={{ 
          position: 'absolute', 
          width: '2px', 
          height: '100%', 
          backgroundColor: '#000' 
        }}></div>

        <div style={{
          position: 'absolute',
          width: '100%',
          height: '2px',
          backgroundColor: '#000'
        }}></div>

        <div style={{ position: 'absolute', top: '-25px', left: '5px', color: '#000', fontSize: '14px', fontWeight: 'bold' }}>
          {topLeft}
        </div>
        <div style={{ position: 'absolute', top: '-25px', right: '5px', color: '#000', fontSize: '14px', fontWeight: 'bold' }}>
          {topRight}
        </div>
        <div style={{ position: 'absolute', bottom: '-25px', left: '5px', color: '#000', fontSize: '14px', fontWeight: 'bold' }}>
          {bottomLeft}
        </div>
        <div style={{ position: 'absolute', bottom: '-25px', right: '5px', color: '#000', fontSize: '14px', fontWeight: 'bold' }}>
          {bottomRight}
        </div>

        <div style={{ position: 'absolute', top: '10px', left: '10px', color: '#000', fontSize: '14px', fontWeight: 'bold' }}>
          {Math.round(scoreRanking[2]?.value)}%
        </div>
        <div style={{ position: 'absolute', top: '10px', right: '10px', color: '#000', fontSize: '14px', fontWeight: 'bold' }}>
          {Math.round(scoreRanking[3]?.value)}%
        </div>
        <div style={{ position: 'absolute', bottom: '10px', left: '10px', color: '#000', fontSize: '14px', fontWeight: 'bold' }}>
          {Math.round(scoreRanking[1]?.value)}%
        </div>
        <div style={{ position: 'absolute', bottom: '10px', right: '10px', color: '#000', fontSize: '14px', fontWeight: 'bold' }}>
          {Math.round(scoreRanking[0]?.value)}%
        </div>

        <svg width="200" height="200" style={{ position: 'absolute', top: '0', left: '0' }}>
          {/* Red dot at bottom right */}
          <circle cx="187" cy="187" r="8" fill="#B6111F" />
          
          <path 
            d="M 187 187 L 62 187 L 62 62 L 187 62" 
            stroke="#B6111F" 
            strokeWidth="5" 
            fill="none" 
            markerEnd="url(#arrowhead)" 
          />
          
          {/* Arrow definition */}
          <defs>
            <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="5" refY="5" orient="auto">
              <polygon points="0 0, 10 5, 0 10" fill="#B6111F" />
            </marker>
          </defs>
        </svg>
      </div>
    );
  }

  const topLeft = sortedScores[2]?.name || "Mind";
  const topRight = sortedScores[3]?.name || "Strength";
  const bottomLeft = sortedScores[1]?.name || "Soul";
  const bottomRight = sortedScores[0]?.name || "Heart";

  return (
    <View style={styles.coverSection}>
      <View style={styles.topSection}>
        <View style={styles.textContent}>
          <Text style={styles.coverTitle}>YOUR QUADRANT FLOW</Text>
          <Text style={styles.paragraph}>
            Quadrant Flow is a dynamic concept in personal development and
            performance. It focuses on how your energy flows from one of four
            foundational quadrants—Heart, Soul, Mind, or Strength.
          </Text>
          <Text style={styles.paragraph}>
            Unlike typical assessments that tend to categorize individuals into
            rigid types, Quadrant Flow recognizes that everyone embodies
            elements of all four quadrants. The primary quadrant is a starting
            point, not a constraint. The flow from one quadrant to another
            offers a more holistic view of who you are and how you lead.
          </Text>
        </View>
        {/* <Image src={FlowImg} style={styles.coverImage} /> */}
        <View style={styles.container}>
          <Text style={[styles.label, styles.topLeft]}>{topLeft}</Text>
          <Text style={[styles.label, styles.topRight]}>{topRight}</Text>
          <Text style={[styles.label, styles.bottomLeft]}>{bottomLeft}</Text>
          <Text style={[styles.label, styles.bottomRight]}>{bottomRight}</Text>

          <Text style={[styles.percentage, styles.pTopLeft]}>{Math.round(scoreRanking[2]?.value)}%</Text>
          <Text style={[styles.percentage, styles.pTopRight]}>{Math.round(scoreRanking[3]?.value)}%</Text>
          <Text style={[styles.percentage, styles.pBottomLeft]}>{Math.round(scoreRanking[1]?.value)}%</Text>
          <Text style={[styles.percentage, styles.pBottomRight]}>{Math.round(scoreRanking[0]?.value)}%</Text>

          <View style={[styles.centerLine, styles.verticalLine]} />
          <View style={[styles.centerLine, styles.horizontalLine]} />

          <Svg height="200" width="200" style={{ position: 'absolute', top: 0, left: 0 }}>
          
            <Circle cx="187" cy="187" r="8" fill="#B6111F" />
            <Path
              d="M 187 187 L 62 187 L 62 62 L 187 62"
              stroke="#B6111F"
              strokeWidth="5"
              fill="none"
            />
            <Polygon points="193,62 166,50 166,74" fill="#B6111F" />
          </Svg>
        </View>
        {/* <SquareWithArrow /> */}
      </View>
      <View style={styles.contentContainer}>
        <Text style={styles.paragraph}>
          Interestingly, the last quadrant individuals flow into often
          represents a weakness or blind spot. However, Quadrant Flow perceives
          this not as a deficiency but as an area for potential growth and
          learning. It may indicate a vulnerability, a lack of awareness, or an
          aspect of oneself that has not been fully recognized or valued.
          Understanding and embracing this last quadrant can be a powerful
          personal and group development tool, offering a more balanced and
          comprehensive self-awareness pathway.
        </Text>
        <Text style={styles.paragraph}>
          The Quadrant Flow journey reflects the intricate tapestry of human
          relationships and personalities. The world, as we know, is complex and
          multi-faceted. Our endeavor is not to oversimplify this complexity but
          to shed light on the nuances of the human condition without stripping
          away its inherent beauty and mystery. By gaining a deeper
          understanding of ourselves and others, we reduce conflict, judgment,
          and confusion and pave the way for greater appreciation,
          collaboration, and respect.
        </Text>
      </View>
    </View>
  );
};

export default QuadrantFlowPage1;
